import { useEffect, useMemo, useState } from 'react'
import { Box, Collapse, Stack } from '@mui/material'
// import { gql, useApolloClient } from '@apollo/client'
import RadioControls from './RadioControls'
import { Field, Logger } from '@wolfdanepug/common-react'
import { SegmentComponentProps } from '../types'
import {
	bodyConditionOptions,
	MAX_WEIGHT_THRESHOLD,
	MIN_WEIGHT_THRESHOLD
} from '../context/onboarding/options'

// const MINIMUM_WEIGHT = 15

export default function Body({ data, setCanStepForward, isMobile }: SegmentComponentProps) {
	const [error, setError] = useState<string>('')

	useEffect(() => {
		Logger.log('[Body] data', data)
	}, [data])

	// the dog object
	const dog = useMemo(() => {
		const key = data?.dogs?.[data.activeDogContext]
		if (!key) return undefined
		const dogData = data?.dog[key]
		return dogData
	}, [data])

	useEffect(() => {
		Logger.log('[Body] dog', dog)
	}, [dog])

	// the dog weight
	const [weight, setWeight] = useState(dog?.weight || undefined)
	const [condition, setCondition] = useState(dog?.bodyCondition || '')
	// the dog gender context
	const genderContext = useMemo(() => {
		return dog?.gender === 'male' ? 'his' : 'her'
	}, [dog?.gender])

	// const validateWeight = (weight: number) => {
	// 	apollo
	// 		.mutate({
	// 			mutation: gql(ValidateMinimumWeight),
	// 			variables: { weight }
	// 		})
	// 		.then(({ data }) => {
	// 			Logger.log(data)
	// 			!data.validateMinimumWeight.success && setError(data.validateMinimumWeight.message)
	// 		})
	// 		.catch((error) => {
	// 			Logger.error(error)
	// 			setError(error.message)
	// 		})
	// 		.finally(() => {})
	// }

	const handleWeightChange = ({ target }: any) => {
		setError('')
		const targetWeight = +target.value as number
		;(targetWeight < MIN_WEIGHT_THRESHOLD || targetWeight > MAX_WEIGHT_THRESHOLD) &&
			setError('Weight must be between 10 and 200 lbs.')
	}

	const handleConditionChange = ({ target }: any) => {
		setCondition(target.value)
	}

	useEffect(() => {
		setCanStepForward(!error && weight > 10 && !!condition)
	}, [error, weight, condition])

	return (
		<>
			{error && <Box color="error">{error}</Box>}
			<Stack direction="row" alignItems="center" gap={2}>
				<Box>{dog?.gender === 'male' ? 'He' : 'She'} weighs</Box>

				<Field
					required
					name={['weight', 'dog']}
					type="number"
					defaultValue={weight}
					variant="standard"
					sx={{ field: { width: 50, '& input': { textAlign: 'center' } } }}
					onChange={({ target }: any) => setWeight(target.value)}
					onFocus={() => setError('')}
					onBlur={handleWeightChange}
				/>
				<Box>lbs.</Box>
			</Stack>

			<Collapse in={weight > 0}>
				<Stack gap={2} p={3}>
					<Box>{genderContext} body condition is currently...</Box>
					<Stack
						alignItems={{
							xs: 'flex-start',
							md: 'center'
						}}
					>
						<RadioControls
							name={['bodyCondition', 'dog']}
							value={dog?.bodyCondition || ''}
							options={bodyConditionOptions}
							sx={{
								gap: { xs: 2, md: 5 },
								flexDirection: isMobile ? 'column' : 'row'
							}}
							onChange={handleConditionChange}
							row={true}
						/>
					</Stack>
				</Stack>
			</Collapse>
		</>
	)
}
